import { Component } from '@angular/core';

@Component({
  selector: 'app-keyboard-arrow-right',
  imports: [],
  templateUrl: './keyboard-arrow-right.component.html',
  styleUrl: './keyboard-arrow-right.component.scss'
})
export class KeyboardArrowRightComponent {

}
